export const isEmptyNumber = (value: string | number) => {
	return value !== 0 && !value;
};

